import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4322ce6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "col-12 d-flex flex-column p-0"
}
const _hoisted_4 = {
  style: {"background":"#203972","border-radius":"10px 10px 0px 0px"},
  class: "col-12 p-4 d-flex flex-row"
}
const _hoisted_5 = {
  key: 0,
  class: "text-white subtitulo col-4 d-flex justify-content-start"
}
const _hoisted_6 = {
  key: 1,
  class: "text-white subtitulo col-4 d-flex justify-content-start"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Busca placa</span><span class=\"text-white subtitulo col-1 d-flex justify-content-center\" data-v-4322ce6a>Valor</span><span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Busca manual</span><span class=\"text-white subtitulo col-1 d-flex justify-content-center\" data-v-4322ce6a>Valor</span><span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Custo total</span>", 5)
const _hoisted_12 = {
  class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
  style: {"background":"#ffff"}
}
const _hoisted_13 = { class: "col-4 d-flex justify-content-start" }
const _hoisted_14 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_15 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_16 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_17 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_18 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_19 = { class: "col-12 d-flex flex-row justify-content-center align-items-center p-2" }
const _hoisted_20 = {
  key: 1,
  class: "col-12 d-flex flex-column p-0"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<li style=\"background:#203972;border-radius:10px 10px 0px 0px;\" class=\"col-12 p-4 d-flex flex-row\" data-v-4322ce6a><span class=\"text-white subtitulo col-4 d-flex justify-content-start\" data-v-4322ce6a>Loja</span><span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Busca placa</span><span class=\"text-white subtitulo col-1 d-flex justify-content-center\" data-v-4322ce6a>Valor</span><span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Busca manual</span><span class=\"text-white subtitulo col-1 d-flex justify-content-center\" data-v-4322ce6a>Valor</span><span class=\"text-white subtitulo col-2 d-flex justify-content-center\" data-v-4322ce6a>Custo total</span></li>", 1)
const _hoisted_22 = { class: "col-4 d-flex justify-content-start" }
const _hoisted_23 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_24 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_25 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_26 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_27 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_28 = { class: "d-flex card p-4 mt-4 flex-row col-12 justify-content-between" }
const _hoisted_29 = { class: "d-flex flex-column gap-2" }
const _hoisted_30 = {
  style: {"font-size":"14px"},
  class: "fw-bold"
}
const _hoisted_31 = { style: {"font-size":"14px"} }
const _hoisted_32 = { style: {"font-size":"14px"} }
const _hoisted_33 = { class: "d-flex flex-column gap-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " ", -1))
const _hoisted_35 = { style: {"font-size":"14px"} }
const _hoisted_36 = { style: {"font-size":"14px"} }
const _hoisted_37 = {
  key: 2,
  class: "card p-4",
  style: {"height":"70dvh"}
}
const _hoisted_38 = {
  key: 3,
  class: "card p-4 d-flex flex-column align-items-center justify-content-center",
  style: {"height":"70dvh"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list-ul mb-6",
  style: {"font-size":"8rem"}
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Faça uma pesquisa", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Custos da operação")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/lojas",
        style: {"height":"fit-content","white-space":"nowrap"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, { text: "Voltar" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.grupoOrConsultor)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            (_ctx.grupoOrConsultor === 'grupo')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Grupo"))
              : _createCommentVNode("", true),
            (_ctx.grupoOrConsultor === 'consultor')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Consultor"))
              : _createCommentVNode("", true),
            _hoisted_7
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.grupoOrConsultorObj && _ctx.grupoOrConsultorObj.nome), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.grupoOrConsultorObj && _ctx.grupoOrConsultorObj.buscas.placa || 0), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.grupoOrConsultorObj.placaValor,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.grupoOrConsultorObj.placaValor) = $event)),
                precision: 2,
                step: 0.1,
                max: 99,
                size: "small",
                "controls-position": "right",
                placeholder: "0.99"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.grupoOrConsultorObj && _ctx.grupoOrConsultorObj.buscas.manual || 0), 1),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.grupoOrConsultorObj.manualValor,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grupoOrConsultorObj.manualValor) = $event)),
                precision: 2,
                step: 0.1,
                max: 99,
                size: "small",
                "controls-position": "right",
                placeholder: "0.99"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.somarCusto(_ctx.grupoOrConsultorObj?.buscas.placa, _ctx.grupoOrConsultorObj?.placaValor || 0, _ctx.grupoOrConsultorObj?.buscas.manual, _ctx.grupoOrConsultorObj?.manualValor || 0)), 1)
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createVNode(_component_el_button, {
              disabled: _ctx.lojas?.length,
              type: "danger",
              onClick: _ctx.mergeLojas
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ver lojas do " + _toDisplayString(_ctx.grupoOrConsultor), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.lojas)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
          _hoisted_21,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojasPaginate, (loja, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
              style: {"background":"#ffff"},
              key: key
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(loja.nomeFantasia), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(loja.placa || 0), 1),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_input_number, {
                  modelValue: loja.placaValor,
                  "onUpdate:modelValue": ($event: any) => ((loja.placaValor) = $event),
                  precision: 2,
                  step: 0.1,
                  max: 99,
                  size: "small",
                  "controls-position": "right",
                  placeholder: "0.99",
                  onInput: ($event: any) => (_ctx.somarCusto(loja.placa, loja.placaValor || 0, loja.manual, loja.manualValor || 0))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_25, _toDisplayString(loja.manual || 0), 1),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_input_number, {
                  modelValue: loja.manualValor,
                  "onUpdate:modelValue": ($event: any) => ((loja.manualValor) = $event),
                  precision: 2,
                  step: 0.1,
                  max: 99,
                  size: "small",
                  "controls-position": "right",
                  placeholder: "0.99",
                  onInput: ($event: any) => (_ctx.somarCusto(loja.placa, loja.placaValor || 0, loja.manual, loja.manualValor || 0))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.somarCusto(loja.placa, loja.placaValor || 0, loja.manual, loja.manualValor || 0)), 1)
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, "Total das lojas selecionadas no periodo de " + _toDisplayString(_ctx.formatarDataParaTemplate(_ctx.dados.dataInicio)) + ":", 1),
              _createElementVNode("span", _hoisted_31, "Placas: " + _toDisplayString(_ctx.totalPlacas), 1),
              _createElementVNode("span", _hoisted_32, "Manual: " + _toDisplayString(_ctx.totalManuais), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, "Total buscas: " + _toDisplayString(_ctx.totalManuais + _ctx.totalPlacas), 1),
              _createElementVNode("span", _hoisted_36, "Custo geral: " + _toDisplayString(_ctx.totalCusto), 1)
            ])
          ]),
          (_openBlock(), _createBlock(_component_Pagination, {
            key: _ctx.route.path,
            arr: _ctx.lojas,
            totalBanco: _ctx.lojas.length,
            onPaginateFront: _ctx.paginateFront,
            tipo: 'Lojas'
          }, null, 8, ["arr", "totalBanco", "onPaginateFront"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.lojas && !_ctx.grupoOrConsultor && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41))
      : _createCommentVNode("", true)
  ]))
}